import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { authSelectors } from "@content-platform/web-angular-shared-util-auth";
import { LoggerService } from "@content-platform/web-angular-shared-util-logging";
import { Store } from "@ngrx/store";
import { catchError, switchMap, throwError } from 'rxjs';
import { API_VERSION, GRAPH_URL, GRAPH_URL_MICROSOFT_BETA } from "../graph-api.config";
import * as i0 from "@angular/core";
import * as i1 from "@content-platform/web-angular-shared-util-logging";
import * as i2 from "@ngrx/store";
/**
 * Interceptor for the Graph Api requests, this adds the authorization token and the api version, that should
 * be on every request.
 *
 * @export
 * @class TokenInterceptor
 */
export class TokenInterceptor {
    constructor(loggerService, store) {
        this.store = store;
        this.logger = loggerService.instance("TokenInterceptor");
    }
    intercept(request, next) {
        if (!request.url.startsWith(GRAPH_URL) && !request.url.startsWith(GRAPH_URL_MICROSOFT_BETA)) {
            return next.handle(request);
        }
        const token$ = this.store.select(authSelectors.getGraphToken);
        return token$.pipe(switchMap((token) => {
            console.log("🚀🚀 token received for " + request.url, token !== undefined);
            request = request.clone({
                setHeaders: { Authorization: `Bearer ${token}` },
                ...(request.url.startsWith(GRAPH_URL) && { setParams: { "api-version": API_VERSION } })
            });
            return next.handle(request).pipe(catchError((err) => {
                console.log("🚀🚀 ERROR in token interceptor", err);
                if (err instanceof HttpErrorResponse && err.status === 403) {
                    this.logger.error(`403 - ${err.message}`);
                }
                return throwError(err);
            }));
        }));
    }
    static { this.ɵfac = function TokenInterceptor_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TokenInterceptor)(i0.ɵɵinject(i1.LoggerService), i0.ɵɵinject(i2.Store)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TokenInterceptor, factory: TokenInterceptor.ɵfac }); }
}
//# sourceMappingURL=token.interceptor.js.map